var _path, _circle, _circle2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentTypeMethodsModalDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 379,
    height: 302,
    viewBox: "0 0 379 302",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.3055 38.1516C91.5966 24.782 138.008 9.66528 194.136 12.885C250.928 16.1408 300.812 37.1915 299.534 46.8145C298.061 57.8741 229.639 48.5687 220.846 74.2469C217.028 85.3931 225.856 99.0227 233.119 106.011C250.221 122.47 270.398 113.403 308.197 121.171C322.823 124.174 367.999 133.465 374.612 156.544C381.189 179.486 347.158 207.301 326.245 224.403C314.492 234.012 243.096 290.595 142.881 285.043C114.243 283.455 82.1252 276.734 80.075 264.108C78.5879 254.94 93.9933 248.991 106.785 222.959C112.496 211.337 119.433 197.216 114.005 189.752C107.681 181.06 90.6437 189.701 55.5302 189.03C35.4396 188.647 8.85911 188.135 4.27501 176.757C-0.915483 163.879 23.0084 139.355 45.4236 125.502C80.0678 104.083 103.436 112.883 126.999 87.9631C135.488 78.9826 145.855 63.671 141.437 56.9212C136.225 48.9513 114.488 59.1735 69.2464 60.5307C56.9524 60.8989 31.4186 61.6713 30.2636 56.1993C29.2674 51.478 46.8096 43.7608 61.3055 38.1516Z",
    fill: "#2B4247"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 103.97,
    cy: 194.43,
    r: 52.7639,
    fill: "#FFDF92"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 330.914,
    cy: 49.572,
    r: 14.5594,
    fill: "#FFDF92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.036 55.8099L119.67 55.5674C116.596 59.295 120.95 77.6683 123.512 86.389L122.784 135.881L126.969 157.442C127.576 165.539 128.589 184.372 127.788 194.925C126.787 208.117 122.238 202.021 116.507 214.94C111.922 225.275 84.7558 244.659 71.7461 253.059C71.7461 280.112 118.254 303.788 125.969 294.181C135.612 282.172 167.363 246.873 178.462 241.05C189.562 235.228 191.199 233.408 198.205 229.587C205.21 225.766 216.4 214.121 223.769 206.752C231.138 199.383 246.514 178.822 251.79 171.362C258.977 159.262 286.011 127.678 286.596 126.685C287.182 125.691 288.149 121.314 286.164 118.056C284.178 114.798 283.72 114.365 279.444 113.856C273.055 115.104 272.953 115.791 271.452 117.318C268.458 121.411 269.797 125.93 270.841 127.678L171.422 156.883L162.52 146.138L150.301 132.322C147.46 128.924 141.534 121.075 140.566 116.858C139.356 111.587 141.185 107.069 141.857 101.394C142.529 95.7198 142.906 93.8103 143.121 87.4365C143.336 81.0628 140.727 75.8454 138.764 71.9459C137.194 68.8262 135.313 66.4148 134.569 65.599L130.911 61.5919L124.403 56.7241L122.036 55.8099Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M147.639 211.959C141.618 210.581 124.545 207.729 121.585 218.991C121.585 218.991 123.751 231.985 98.4841 248.589C82.4795 259.107 75.1666 256.299 71.9541 252.826C77.7149 247.968 127.599 205.361 125.556 189.032C123.39 171.706 112.561 134.889 116.893 111.066C121.224 87.2431 114.727 61.9765 117.615 56.9231C118.113 56.0568 118.871 55.602 119.838 55.501H119.845C126.299 58.172 132.753 64.6692 129.526 80.385C123.751 108.539 121.859 121.1 130.385 140.808C138.911 160.516 132.414 156.185 132.414 168.457C132.414 180.73 129.05 206.271 147.639 211.959Z",
    fill: "#CCEDED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M286.9 125.866C286.178 128.753 271.019 143.913 254.415 167.736C216.637 221.944 195.94 231.986 180.08 240.151C164.35 248.257 126.349 294.026 125.757 294.741C122.241 295.109 119.079 294.784 118.754 292.503C118.011 287.175 152.973 231.365 160.827 225.193C168.674 219.028 183.35 215.656 200.647 210.892C217.944 206.127 241.781 173.215 247.766 167.144C253.751 161.066 254.4 155.738 254.4 155.738C260.385 152.93 269.734 140.968 277.068 134.514C284.403 128.068 283.479 120.365 283.479 120.365L286.027 117.925C287.377 120.834 287.247 124.487 286.9 125.866Z",
    fill: "#CCEDED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M276.072 132.36C273.913 132.093 271.856 130.108 270.607 127.538",
    stroke: "#13787A",
    strokeWidth: 0.721905,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M267.893 68.516L266.298 50.8799",
    stroke: "#13787A",
    strokeWidth: 0.721905,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M271.603 109.695L271.589 109.521",
    stroke: "#13787A",
    strokeWidth: 0.721905,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9541 252.826C77.7149 247.968 127.599 205.361 125.556 189.032C123.39 171.706 112.561 134.889 116.893 111.066C121.224 87.2431 114.727 61.9765 117.615 56.9231C118.113 56.0568 118.871 55.602 119.838 55.501H119.845",
    stroke: "#13787A",
    strokeWidth: 0.721905,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.954 252.825C71.6003 253.121 71.4126 253.28 71.4126 253.28",
    stroke: "#13787A",
    strokeWidth: 0.721905,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M271.163 128.529L171.677 156.921C171.677 156.921 157.073 140.664 157.737 140.844C158.401 141.025 271.156 127.475 271.156 127.475V128.529H271.163Z",
    fill: "#13787A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M202.216 148.197C202.216 148.197 192.981 155.173 191.862 162.089C190.736 169.012 188.78 179.667 180.081 180.692C180.038 180.692 179.994 180.692 179.951 180.692C180.817 171.841 177.229 164.319 171.642 156.869L202.216 148.197Z",
    fill: "#CCEDED"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M168.87 204.191C175.973 195.182 179.294 187.544 179.951 180.7C180.817 171.85 177.229 164.327 171.642 156.877C167.715 151.643 162.799 146.439 157.738 140.844",
    stroke: "#13787A",
    strokeWidth: 0.721905,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4126 253.281C71.4126 253.281 127.721 206.357 125.555 189.031C123.39 171.705 112.561 134.888 116.893 111.065C121.224 87.2424 114.727 61.9757 117.615 56.9224C119.831 53.0458 127.533 57.4277 133.778 64.6829",
    stroke: "#13787A",
    strokeWidth: 0.721905,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M125.75 294.746C126.342 294.024 164.343 248.255 180.073 240.148C195.934 231.983 216.631 221.942 254.408 167.734C271.012 143.911 286.172 128.751 286.894 125.863C287.24 124.485 287.37 120.832 286.02 117.922C284.547 114.746 281.299 112.465 274.621 115.035C273.676 115.403 272.867 115.865 272.203 116.399",
    stroke: "#13787A",
    strokeWidth: 0.721905,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M252.25 153.297C252.25 153.297 250.806 147.522 247.197 146.078",
    stroke: "#13787A",
    strokeWidth: 0.721905,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M240.7 139.582L237.09 136.694",
    stroke: "#13787A",
    strokeWidth: 0.721905,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M271.741 114.314L278.534 109.99C275.126 112.676 272.022 114.314 271.741 114.314Z",
    fill: "white",
    stroke: "#13787A",
    strokeWidth: 0.721905,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M278.549 109.983C275.633 110.315 273.359 110.17 271.604 109.694C265.569 108.055 265.714 102.446 267.157 98.4034C267.829 96.512 268.847 94.7723 270.124 93.2563C271.157 92.0218 272.362 90.9317 273.712 90.0221C274.008 89.82 274.311 89.6251 274.629 89.4302C275.676 88.7877 276.824 88.1885 277.986 87.7698C281.444 86.5281 285.111 86.8457 287.132 91.9785C289.912 99.0387 283.862 105.789 278.549 109.983Z",
    fill: "white",
    stroke: "#13787A",
    strokeWidth: 0.721905,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M274.521 92.0358C276.982 92.3534 282.101 93.6456 283.147 98.8578C283.227 99.2548 283.739 99.3776 283.977 99.0527C284.779 97.941 285.948 95.8258 285.465 93.3785C284.779 89.9639 280.873 87.199 274.347 91.1767C273.972 91.4077 274.095 91.978 274.528 92.0358H274.521Z",
    fill: "#13787A",
    stroke: "#13787A",
    strokeWidth: 0.721905,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M277.631 116.943C279.132 117.022 283.348 117.744 284.648 123.281C284.676 123.389 284.821 123.396 284.85 123.288C285.333 121.325 286.871 113.174 277.602 116.733C277.494 116.777 277.515 116.935 277.631 116.943Z",
    fill: "#13787A",
    stroke: "#13787A",
    strokeWidth: 0.721905,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M267.893 68.516C267.734 68.6243 267.575 68.7254 267.409 68.8337L266.298 50.8799C266.298 50.8799 273.906 47.1765 276.072 52.2299C278.202 57.2038 277.538 62.1705 267.893 68.516Z",
    fill: "white",
    stroke: "#13787A",
    strokeWidth: 0.721905,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M270.608 127.54C256.61 129.265 189.235 137.553 157.738 140.845C152.367 134.911 146.837 128.522 142.159 121.173C137.683 114.141 142.896 102.273 142.997 89.344C143.04 83.641 142.087 77.7286 138.875 71.9389C138.55 71.3541 138.21 70.7766 137.857 70.2135C136.637 68.2572 135.251 66.3874 133.778 64.6837C133.684 63.7814 133.598 62.9295 133.518 62.1282C133.056 57.5802 136.348 53.5087 140.896 53.0033L256.776 40.1029C261.425 39.5903 265.591 42.9905 266.009 47.6468L266.298 50.8809L266.587 55.4939L267.41 68.8347C267.576 68.7264 267.735 68.6253 267.893 68.5171L268.124 71.087C267.107 71.8378 266.154 72.8341 265.453 74.1479C265.042 74.9131 264.724 75.7794 264.522 76.7757C263.331 82.7386 265.071 88.4849 269.799 89.6689L270.124 93.2567C268.846 94.7727 267.828 96.5125 267.157 98.4039C265.713 102.447 265.569 108.056 271.604 109.695L272.21 116.401C267.583 120.971 270.608 127.54 270.608 127.54Z",
    fill: "white",
    stroke: "#13787A",
    strokeWidth: 0.721905,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M147.212 109.622L178.254 106.013",
    stroke: "#13787A",
    strokeWidth: 1.44381,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M184.03 105.291L195.58 103.848",
    stroke: "#13787A",
    strokeWidth: 1.44381,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M117.997 79.8352C117.997 79.8352 122.675 74.2476 120.509 64.141C118.344 54.0343 115.153 55.1966 115.305 59.3042C115.456 63.4118 115.492 76.038 117.997 79.8352Z",
    fill: "#13787A",
    stroke: "#13787A",
    strokeWidth: 0.721905,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M252.257 133.365C252.257 133.365 243.226 142.83 243.948 143.551C244.67 144.273 257.664 132.001 257.664 132.001",
    stroke: "#13787A",
    strokeWidth: 0.721905,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M268.362 73.7716C268.362 73.7716 267.33 73.9015 265.453 74.147C248.964 76.2622 167.1 86.7514 142.996 89.3431C143.039 83.64 142.086 77.7276 138.874 71.9379C138.549 71.3532 138.21 70.7757 137.856 70.2126L266.586 55.493L266.716 55.4785L267.893 68.5161L268.124 71.0861L268.362 73.7716Z",
    fill: "#13787A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M277.986 87.7699C276.823 88.1886 275.675 88.7878 274.629 89.4303C274.159 89.5819 273.676 89.6901 273.185 89.7695C271.922 89.9645 270.795 89.9211 269.799 89.6685C265.071 88.4846 263.331 82.7382 264.522 76.7753C265.063 74.0681 266.522 72.2778 268.124 71.0867C270.803 69.1159 273.907 68.8343 273.907 68.8343C281.126 68.1124 284.327 72.7207 284.735 76.0534C285.187 79.736 282.519 84.6368 277.986 87.7699Z",
    fill: "white",
    stroke: "#13787A",
    strokeWidth: 0.721905,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M282.409 74.2332C279.512 69.3827 274.403 69.6669 272.21 70.4153C280.138 70.9459 281.607 78.0507 281.841 80.8475C282.918 79.1327 283.447 76.05 282.409 74.2332Z",
    fill: "#13787A",
    stroke: "#13787A",
    strokeWidth: 0.721905,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentTypeMethodsModalDark);
export default __webpack_public_path__ + "static/media/PaymentTypeMethodsModalDark.28d40cc0f1f5920ed066fd94dfeda2e8.svg";
export { ForwardRef as ReactComponent };